<template>
	<div
		class="text-label-tertiary inline-flex h-9 shrink-0 items-center rounded-full px-3 text-xs font-medium whitespace-nowrap uppercase"
		:class="{
			'bg-fill-secondary': alt,
			'bg-fill-tertiary': !alt
		}"
	>
		<slot />
	</div>
</template>
<script setup lang="ts">
defineProps<{
	alt?: boolean
}>()
</script>
